import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddTeamMember from "./ModalAddTeamMember";

const useModalAddTeamMember = (onSaveCompleted ) =>
{
    const CLOSED_EMPTY = { openState: false, team_id: null, filter: null } ;

    const [dialog, setDialog]  = useState ( CLOSED_EMPTY )  ;

    const onClickActivate = ( team_id, filter ) =>
    {
        setDialog ({ openState: true, team_id: team_id, filter: filter });
    }

    const onCloseModal = () =>
    {
        setDialog (CLOSED_EMPTY);
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog (CLOSED_EMPTY);
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddTeamMember team_id={dialog.team_id} filter={dialog.filter} onSaveCompleted={onSaveComplete} onClose={onCloseModal} width={'600px'}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddTeamMember ;
